/* screens/workspace/feed/SourcesBlock.jsx — чипы-источники под завершённым ответом (S6).
   Каждый чип ведёт на canonical-поверхность сущности (kind ttk/ingredient_card/menu/
   document/report/restaurant + title + url). Клик → navigate (внутренние) или toast.
   Источник: 07 §2.14. ХЕНДОФФ → frontend/components/chat/SourcesBlock.jsx (замена). */

import { useToast } from '../../../app/providers/ToastProvider.jsx';
import { Icon } from '../../../components/ui/Icon.jsx';
import { RR } from '../../../lib/router.jsx';

  const { useNavigate } = RR;

  const KIND_ICON = { ttk: 'book', ingredient_card: 'tag', menu: 'reports', document: 'file-text', report: 'analytics', restaurant: 'building' };

  function SourcesBlock({ sources }) {
    const navigate = useNavigate();
    const toast = useToast();
    if (!sources || !sources.length) return null;
    const open = (s) => (e) => {
      e.preventDefault();
      if (!s.url || s.url === '#') { toast.show('Источник недоступен', 'muted'); return; }
      if (/^https?:/.test(s.url)) window.open(s.url, '_blank', 'noopener');
      else navigate(s.url);
    };
    return (
      <div className="sources-block">
        <div className="sources-block__label"><Icon name="link" size={13} /> Источники</div>
        <div className="sources-block__list">
          {sources.map((s, i) => (
            <a key={i} className="sources-block__item" href={s.url || '#'} onClick={open(s)}>
              <Icon name={KIND_ICON[s.kind] || 'file'} size={13} />
              <span className="truncate">{s.title}</span>
            </a>
          ))}
        </div>
      </div>
    );
  }

export { SourcesBlock };
